import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiFileOn } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { Enumerations } from "../../config/Enumerations";
import { VscOpenPreview } from "react-icons/vsc";
import { LiaDownloadSolid } from "react-icons/lia";
import { AppEntryAttachmentsRepository } from "../repositories/AppEntryAttachmentsRepository";
import PDFDialogViewer from "../common/PdfDialogViewer";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import { notifyShowErrorMessage } from "../../store/AlertSlice";
import { useDispatch } from "react-redux";
import { SETTINGS } from "../../Settings";

export default function EntryCorrectedAttachments({
  appEntry,
  correctedDocuments,
}) {
  const theme = useTheme();
  const [openOtherDocuments, setOpenOtherDocuments] = useState(false);
  const [previewPdf, setPreviewPdf] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = React.useState(null);
  const [dwgPreview, setDwgPreview] = React.useState(null);

  const previewAttachment = (attachment) => {
    AppEntryAttachmentsRepository.getAttachment(attachment.id).then(
      (response) => {
        const file = new Blob([response.data], { type: response.data.type });
        if (attachment.fileType === "application/pdf") {
          setPreviewPdf(file);
        }
        if (attachment.fileType.startsWith("image/")) {
          setImagePreview(URL.createObjectURL(file));
        }
        // TODO: implement DWG preview
        // if (
        //   attachment.fileType.startsWith("application/octet-stream") &&
        //   attachment.fileName.endsWith(".dwg")
        // ) {
        //   setDwgPreview(URL.createObjectURL(file));
        //   window.open(
        //     "https://sharecad.org/cadframe/load?url=" +
        //       URL.createObjectURL(file),
        //     "_blank"
        //   );
        // }
      }
    );
  };

  const downloadAttachment = (attachment) => {
    setSaving(true);
    const url = `${SETTINGS.EXTERNAL_API_URL}external/appEntries/attachments/${
      attachment?.id
    }?token=${localStorage.getItem("accessToken")}`;

    console.log("Downloading from URL:", url);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", attachment?.fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setSaving(false);
  };

  useEffect(() => {
    if (correctedDocuments?.length > 0 && appEntry) {
      setOpenOtherDocuments(true);
    }
  }, [appEntry]);

  return (
    <Grid item xs={12} className="other-documents-container">
      <div
        className={`other-documents-header ${
          openOtherDocuments ? "with-padding" : "no-bottom-padding"
        }`}
      >
        <div className="other-documents-title-container">
          <div className="other-documents-title">
            <Typography variant="h6" className="title-text">
              Коригирани документи
            </Typography>
            <Typography
              variant="caption"
              className="document-count"
              style={{ backgroundColor: theme.palette.primary.main }}
            >
              {correctedDocuments?.length}
            </Typography>
          </div>
        </div>
        <IconButton
          disabled={correctedDocuments?.length === 0}
          className="toggle-button"
          onClick={() => setOpenOtherDocuments(!openOtherDocuments)}
        >
          <IoIosArrowDown
            className={openOtherDocuments ? "rotate-arrow" : ""}
          />
        </IconButton>
      </div>

      {correctedDocuments?.length > 0 && openOtherDocuments && (
        <Box className="other-documents-box">
          {correctedDocuments?.map((attachment, index) => (
            <ListItem key={index} className="document-item dark-border">
              <div className="document-icon">
                <CiFileOn color="#2d2d2d" size={25} />
              </div>
              <div className="document-details">
                <Typography variant="inherit" className="document-type dark">
                  {Enumerations.DocumentType[attachment.documentType] ||
                    attachment.type}
                </Typography>
                <Typography variant="inherit" className="document-name dark">
                  {attachment.fileName}
                </Typography>
              </div>
              <div className="document-actions">
                <IconButton
                  className="document-icon-button"
                  onClick={() => downloadAttachment(attachment)}
                >
                  <LiaDownloadSolid color="#2d2d2d" />
                </IconButton>
              </div>
            </ListItem>
          ))}
        </Box>
      )}

      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Grid>
  );
}
